import { ReactNode, SelectHTMLAttributes, useMemo } from 'react';
import { darkModeAware } from '@glu/theming';
import { CaretDownIcon } from '@glu/icons-react';
import classnames from 'classnames';
import useStyles from './SelectBase.styles';

export interface ISelectBaseProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** True if the select should be in dark mode which styles it for dark colored forms */
  dark?: boolean;
  /** error message for the select */
  error?: string;
  /** Content for the first option, including the <option> tag set null/false to not use */
  firstOption?: ReactNode;
  /** Html id to use for the select */
  htmlId?: string;
  /** Use warning styles for error if true */
  warning?: boolean;
}

let uniqueId = 0;

// eslint-disable-next-line jsx-a11y/control-has-associated-label
const defaultFirstOption = <option value="" />;

const SelectBase = ({
  children,
  className,
  dark,
  error,
  firstOption = defaultFirstOption,
  htmlId,
  name,
  onChange,
  value,
  warning,
  ...rest
}: ISelectBaseProps) => {
  const classes = useStyles();
  // eslint-disable-next-line no-plusplus
  const id = useMemo(() => htmlId || `input-${uniqueId++}`, [htmlId]);
  return (
    <div className={classnames(classes.root, { [classes.darkRoot]: dark }, className)}>
      <select
        className={classnames(classes.select, {
          [classes.dark]: dark,
          [classes.error]: !!error,
          [classes.warning]: warning,
        })}
        id={id}
        name={name}
        onChange={onChange}
        value={value !== undefined && value !== null ? value : ''}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      >
        {firstOption}
        {children}
      </select>
      <CaretDownIcon focusable={false} noIconWrapper />
      <span className={classnames(classes.caret, { [classes.dark]: dark })} />
    </div>
  );
};

export { SelectBase as BareSelect };
export default darkModeAware(SelectBase);
